import { useLazyIndexedDBGraphqlQuery } from '@repo/services';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { type AttributeOptionsType } from '../queries';
import { setLeadStageOptions } from '../stores';

export interface GetLeadAttributeOptionsType {
  leadAttributeOptions: AttributeOptionsType[];
}

export const getLeadStages = `
  query getLeadStage {
    leadAttributeOptions: leadStages {
      value: leadStageUuid
      label: name
      config {
        colorScheme
      }
    }
  }
`;

const useFetchLeadStageOptions = ({ skip = false }: { skip?: boolean } = {}) => {
  const dispatch = useDispatch();
  const [fetchLeadStageOptions,
    { data: leadStageOptions, isLoading },
  ] = useLazyIndexedDBGraphqlQuery<GetLeadAttributeOptionsType>({
    cacheKey: 'leadStageOptions',
    document: getLeadStages,
  });

  useEffect(() => {
    if (!skip && !isLoading && !leadStageOptions) {
      fetchLeadStageOptions({ document: getLeadStages });
    }
  }, [fetchLeadStageOptions, skip, leadStageOptions, isLoading]);

  useEffect(() => {
    if (leadStageOptions?.leadAttributeOptions) {
      dispatch(setLeadStageOptions({ data: leadStageOptions.leadAttributeOptions }));
    }
  }, [leadStageOptions, dispatch]);

  return {
    fetchLeadStageOptions,
    leadStageOptions,
    isLoading,
  };
};

export default useFetchLeadStageOptions;
